export const initAccountNotificationUpdate = () => {
  const container = document.querySelector("[data-notifications-url]") as HTMLElement | null;

  if (!container) {
    return;
  }

  const notificationUrl = container.dataset.notificationsUrl as string;

  const checkboxes: NodeListOf<HTMLInputElement> = container.querySelectorAll(
    "input.notification-checkbox",
  );

  const snapshotChecked = (): Set<string> =>
    new Set(
      Array.from(
        container.querySelectorAll<HTMLInputElement>(
          'input.notification-checkbox[type="checkbox"]:checked',
        ),
      ).map((el) => el.name),
    );

  let lastSavedState = snapshotChecked();
  let debounceTimer: ReturnType<typeof setTimeout> | null = null;

  const save = () => {
    const pendingState = snapshotChecked();
    const body = Array.from(pendingState)
      .map((name) => `notification_types[]=${encodeURIComponent(name)}`)
      .join("&");

    fetch(notificationUrl, {
      credentials: "same-origin",
      method: "put",
      body: body,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Notification update failed: ${response.status}`);
        }

        lastSavedState = pendingState;
      })
      .catch(() => {
        checkboxes.forEach((cb) => {
          if (cb.disabled) {
            return;
          }

          cb.checked = lastSavedState.has(cb.name);
        });
      });
  };

  checkboxes.forEach((checkbox) => {
    if (checkbox.disabled) {
      return;
    }

    checkbox.addEventListener("change", () => {
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }

      debounceTimer = setTimeout(save, 400);
    });
  });
};
